// Angular
import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
// Material
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
// Translate
import { TranslateModule } from "@ngx-translate/core";
// CRUD
import { InterceptService } from "../../../core/_base/crud/";
// Module components
import { AuthComponent } from "./auth.component";
import { AuthNoticeComponent } from "./auth-notice/auth-notice.component";
// Auth
import { AuthService } from "../../../core/auth/_services/auth.service";
import { AuthGuard } from "../../../core/auth/_guards/auth.guard";
import { AuthCallbackComponent } from "./auth-callback/auth-callback.component";
import { LogoutCallbackComponent } from "./logout-callback/logout-callback.component";
import { LoginComponent } from "./login/login.component";
import { PartialsModule } from "../../partials/partials.module";
import { InformationDialogComponent } from "./information-dialog/information-dialog.component";
// import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MaterialModule } from '../material.module';
import { SharedModule } from "@app/shared/shared.module";

const routes: Routes = [];

@NgModule({
	imports: [
		CommonModule,
		RouterModule.forChild(routes),
		TranslateModule.forChild(),
		PartialsModule,
		// PerfectScrollbarModule,
		MaterialModule,
		SharedModule
	],
	providers: [
		InterceptService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: InterceptService,
			multi: true,
		},
	],
	exports: [AuthComponent],
	declarations: [
		LoginComponent,
		AuthComponent,
		AuthNoticeComponent,
		AuthCallbackComponent,
		LogoutCallbackComponent,
		InformationDialogComponent,
	]
})
export class AuthModule {
	static forRoot(): ModuleWithProviders<AuthModule> {
		return {
			ngModule: AuthModule,
			providers: [AuthService, AuthGuard],
		};
	}
}
